import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import type { Entity, ID } from 'src/lib/collection';
import { getSingleProp } from 'src/lib/graphql';

const MUTATION = gql`
  mutation SwitchBlogPostBuilderOutlineSections($sectionId1: ID!, $sectionId2: ID!) {
    switchBlogPostBuilderOutlineSections(sectionId1: $sectionId1, sectionId2: $sectionId2) {
      id
    }
  }
`;

interface Params {
  sectionId1: ID;
  sectionId2: ID;
}

export const switchBlogPostBuilderOutlineSections = async ({ sectionId1, sectionId2 }: Params) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables: { sectionId1, sectionId2 },
  });

  return getSingleProp<Entity[]>(result.data);
};
